import { useEffect, useState } from "react";

export function useRetryCountdown(initialSeconds: number | null) {
  const [secondsRemaining, setSecondsRemaining] = useState<number | null>(
    initialSeconds,
  );

  useEffect(() => {
    if (secondsRemaining === null || secondsRemaining <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setSecondsRemaining((prev) => {
        if (prev === null || prev <= 1) {
          return null;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [secondsRemaining]);

  const startCountdown = (seconds: number) => {
    setSecondsRemaining(seconds);
  };

  const clearCountdown = () => {
    setSecondsRemaining(null);
  };

  return {
    secondsRemaining,
    startCountdown,
    clearCountdown,
    isActive: secondsRemaining !== null && secondsRemaining > 0,
  };
}
